import { CurrencyPipe } from '@angular/common';
import { Pipe, PipeTransform, inject } from '@angular/core';

/**
 * Converts amount into Aus currency without decimal
 * example: {{listing.price | ausCurrencyWithoutDecimal}} => '$999'
 */
@Pipe({
    name: 'ausCurrencyWithoutDecimal',
    standalone: false
})
export class AusCurrencyWithoutDecimalPipe implements PipeTransform {
  private currencyPipe = inject(CurrencyPipe);


  transform(value: number | undefined): string {
    if (!value) {
      return '$0';
    }

    return this.currencyPipe.transform(value.toFixed(), 'AUD', 'symbol-narrow', '1.0-0');
  }
}
